import { ICON_TYPES } from '../constants';

export const CheckboxIcon = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.625 0H4.37501C1.95997 0.00291211 0.00291211 1.95997 0 4.37501V16.625C0.00291211 19.04 1.95997 20.9971 4.37501 21H16.625C19.04 20.9971 20.9971 19.04 21 16.625V4.37501C20.9971 1.95997 19.04 0.00291211 16.625 0ZM17.5 7.06913L9.40275 15.1664C8.71947 15.85 7.61143 15.8502 6.92787 15.1669C6.9277 15.1667 6.92754 15.1666 6.92737 15.1664L3.49999 11.7399C3.15759 11.3975 3.15759 10.8424 3.49999 10.5C3.84238 10.1577 4.39749 10.1576 4.73985 10.5L8.16633 13.9265L16.2645 5.82926C16.6069 5.4881 17.161 5.48908 17.5021 5.83144C17.8434 6.17384 17.8424 6.72796 17.5 7.06913Z"
        fill="#141414"
      />
    </svg>
  );
};

CheckboxIcon.iconType = ICON_TYPES.CHECKBOX;
